import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController, ModalController, ToastController } from 'ionic-angular';
import { TPVServices } from "../../services";
import { Globals } from "../../../../globals";
import { ReservationLoaderPage } from "../../../reservation/reservation-loader/reservation-loader";
import { TpvTicketSelectedCashPage } from "./tpv-ticket-selected-cash/tpv-ticket-selected-cash";
import { PrintServices } from "../../../services/printServices";
import { TpvTicketPage } from "../tpv-ticket";
import { InvoicesCreateSelectClientPage } from "../../../invoices/invoices-create/invoices-create-select-client/invoices-create-select-client";
import { TpvCashInoutCreatePage } from "../../tpv-cash-inout-create/tpv-cash-inout-create";
import { ConfigurationTicketsPage } from '../../../configuration/configuration-tickets/configuration-tickets';
import { ConfigurationServices } from '../../../configuration/services';
import { BlockScreenPage } from '../../../components/block-screen/block-screen';
import { OrdersCoServices } from '../../../orders/services';
import { TpvTicketSelectElementPage } from './tpv-ticket-select-element/tpv-ticket-select-element';
import { TranslateService } from '@ngx-translate/core';
import { SelectedPersonsPage } from '../../../components/selected-persons/selected-persons';
import { CustomersCreateDataPage } from '../../../customers/customers-create/customers-create-data/customers-create-data';
import { TpvTicketChangeTablePage } from './tpv-ticket-change-table/tpv-ticket-change-table';
import * as moment from 'moment';
import { getCurrencySymbol } from '@angular/common';
import * as firebase from 'firebase';
import { PrintTicketOrETicket } from '../../../components/popups/print-ticket-or-eticket/print-ticket-or-eticket';
import { PopupSelectPayment } from '../../../components/popups/popup-select-payment/popup-select-payment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PopupSelectCustomer } from '../../../components/popups/popup-select-customer/popup-select-customer';
import { TpvLoaderPage } from '../../tpv-loader/tpv-loader';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';


/**
 * Generated class for the TpvTicketSelectedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-tpv-ticket-selected',
    templateUrl: 'tpv-ticket-selected.html',
})
export class TpvTicketSelectedPage {
    public firestore;
    qr_link: string = '';
    qr_link_done: boolean = false;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public tpvServices: TPVServices,
        public globals: Globals,
        private alertCtrl: AlertController,
        public printServices: PrintServices,
        public configurationServices: ConfigurationServices,
        public ordersCoServices: OrdersCoServices,
        public loadingCtrl: LoadingController,
        public translate: TranslateService,
        private modalCtrl: ModalController,
        private toastCtrl: ToastController,
        public http: HttpClient,
    ) {
        this.firestore = firebase.firestore();
        this.checkInfo();
    }

    checkInfo() {
        if (this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer == undefined) {
            this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer = {};

        }
    }
    ngOnInit() {
        this.tpvServices.deleteKeyboard();
        this.tpvServices.change_units = false;

    }

    styleHeight() {
        //get height screen
        var height = window.innerHeight;
        if ((this.globals.trial_days > 0 && this.globals.trial_days <= 15) || (this.globals.trial_days == 0 && this.globals.restaurant.license === 'free')) {
            height = height - 91;
        } else {
            height = height - 51;
        }
        height = height / 2;
        let styles = {
            'height': height + 'px',
            'overflow': 'hidden',
        };
        return styles;
    }

    openPersons() {
        if (this.globals.checkLimitsByLicense('sales', 'customers')) {
            let profileModal = this.modalCtrl.create(SelectedPersonsPage, {
                origin: 'tpv',
                update: true
            });
            profileModal.present();
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    async printOrETicket(customer = "") {
        try {

            if (customer == "") {
                customer = this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer;
            }
            //Comprovamos si el ticket digital esta activado
            if (this.globals.restaurant.tickets.ticket_digital || this.globals.restaurant.tickets.ticket_digital == undefined) {
                let profileModal = this.modalCtrl.create(PrintTicketOrETicket,
                    {
                        title: this.translate.instant('general-ticket'),
                        customer: customer,
                        table: 'tpv',

                    });
                profileModal.onDidDismiss(async data => {
                    if (data != undefined) {
                        if (data == "printTicket") {
                            this.ticketPrint();
                        } else if (data == "eTicket") {

                            if (this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer.email != undefined) {

                                let url_mctpay = await this.createMctPayCharge();

                                await this.tpvServices.getTicketNumber(this.globals.restaurant_uid, this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].cash_uid)


                                this.eTicket(
                                    this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket,
                                    this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer,
                                    url_mctpay, //link
                                    this.tpvServices.totalTicketSelectedNoTax(this.tpvServices.selected_table_tpv_index, this.globals.RESTAURANT_TAX),
                                    "mesa");
                                //notificamos al usuario de que el ticket se envio
                                let toast = this.toastCtrl.create({
                                    message: this.translate.instant('eticket-ticket-digital-enviado-correctamente'),
                                    duration: 3000,
                                    position: 'bottom'
                                });
                                toast.present();
                            } else {


                                let profileModalPopup = await this.modalCtrl.create(PopupSelectCustomer,
                                    {
                                        title: this.translate.instant('general-selecciona-cliente'),
                                    });
                                profileModalPopup.onDidDismiss(async data => {
                                    if (data != undefined) {
                                        this.tpvServices.tableUpdateCustomer(data);
                                        this.printOrETicket(data);

                                    } else {
                                        this.printOrETicket();
                                    }

                                });

                                profileModalPopup.present();

                            }
                        } else if (data == "editCustomer") {

                            let profileModalPopup = await this.modalCtrl.create(PopupSelectCustomer,
                                {
                                    title: this.translate.instant('general-selecciona-cliente'),
                                });
                            profileModalPopup.onDidDismiss(async data => {
                                if (data != undefined) {
                                    this.tpvServices.tableUpdateCustomer(data);
                                    this.printOrETicket(data);

                                } else {
                                    this.printOrETicket();
                                }

                            });

                            profileModalPopup.present();

                        }

                    } else {

                    }
                });

                profileModal.present();
            } else {
                this.ticketPrint();
            }
        } catch (error) {
            //notificamos al usuario de que el ticket no se puedo enviar correctamente
            let toast = this.toastCtrl.create({
                message: this.translate.instant('eticket-error-al-enviar-ticket-digital'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    async createMctPayCharge() {
        //Recuperamos la url del mct_pay_web, para el qr
        try {
            const params = new HttpParams()
                .set('public_key', this.globals.public_key)
                .set('table_uid', this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].UID);

            const url_mctpay = await this.http.post(this.globals.analytics_path + 'mctwebpay/create_mct_pay_charge', params, {}).toPromise()
            return url_mctpay['url_mct_pay_charge'];
        } catch (error) {
            return "";
        }

    }

    eTicket(ticket, customer, mct_pay_charge, subtotal, type) {
        //tener en cuenta que el email y otros datos si viene de deliverecto no son el customer_name y etc

        var _date = '';
        if (ticket.date.seconds) {
            _date = moment(new Date(this.globals.timestampToDate(ticket.date))).format('YYYY/MM/DD HH:mm');
        } else {
            _date = moment(ticket.date).format('YYYY/MM/DD HH:mm');
        }

        let _email = {
            'UID_RESTAURANT': this.globals.restaurant_uid,
            'type': 'eticket_mctpay',
            'customer_name': this.globals.ifVarEmpty(customer.name),
            'customer_email': this.globals.ifVarEmpty(customer.email),
            'customer_phone': this.globals.ifVarEmpty(customer.phone),
            'takeaway_type': type,
            'ticket_number': ticket.number,
            'ticket_list': ticket.list,
            'ticket_date': _date,
            'ticket_currency': getCurrencySymbol(this.globals.user_currency, 'narrow', 'es'),
            'ticket_subtotal': subtotal,
            'ticket_total': this.tpvServices.totalTicketSelected(this.tpvServices.selected_table_tpv_index),
            'ticket_tax_name': this.globals.user_tax_name,
            'ticket_tax': this.globals.RESTAURANT_TAX,
            'restaurant_company': this.globals.restaurant.company,
            'restaurant_address': this.globals.restaurant.address,
            'restaurant_email': this.globals.restaurant.email,
            'restaurant_phone': this.globals.restaurant.phone,
            'restaurant_logo': this.getImageUrl(this.globals.restaurant.logo), //this.restaurant.logo
            'order_status': "",
            'mct_pay_charge': mct_pay_charge
        }
        this.firestore.collection('_emails').add(_email);
    }

    getImageUrl(img_url) {
        if (img_url != '' && img_url != undefined) {
            img_url = 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/' + img_url.replace('logo/', 'logo%2F') + '?alt=media';
            return img_url;
        } else {
            return '';
        }

    }
    async ticketPrint() {

        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('instant-imprimiendo')
        });
        loadingPopup.present();
        //loader general
        this.globals.GAtrackView('TPV', 'TPV - Ticket - Print', this.globals.restaurant.email, 'View', 'Print TPV ticket ', 'TPV', '');
        //get ticket number
        if (this.globals.connection) {
            await this.tpvServices.getTicketNumber(this.globals.restaurant_uid, this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].cash_uid)
        } else {
            await this.tpvServices.getTicketNumberOffline();
        }

        if (this.globals.restaurant.printer_type == 'native') {
            this.globals.print_content = document.getElementById('print_list_ticket_normal');
            this.tpvServices.ticket_print = 'normal';
            //interval
            var interval_native = setInterval(() => {
                this.printServices.printNow('print_list_ticket_normal');
                this.tpvServices.deleteKeyboard();
                clearInterval(interval_native);
                //Acaba loader general
                loadingPopup.dismiss();
            }, 3000);
        } else {
            var interval_services = setInterval(() => {
                this.printServices.prepareTicket(this.tpvServices.listSelectedTicket('name', this.globals.objectToArray(this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.list))[0]
                    , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.date.toDate()
                    , this.tpvServices.totalTicketSelectedNoTax(this.tpvServices.selected_table_tpv_index, this.globals.RESTAURANT_TAX)
                    , this.tpvServices.totalTicketSelected(this.tpvServices.selected_table_tpv_index)
                    , this.tpvServices.calculateIva(this.tpvServices.totalTicketSelected(this.tpvServices.selected_table_tpv_index), this.tpvServices.totalTicketSelectedNoTax(this.tpvServices.selected_table_tpv_index, this.globals.RESTAURANT_TAX), this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket)
                    , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.waiter
                    , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].room
                    , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].name
                    , this.globals.restaurant.tickets.footer
                    , 'tpv'
                    , this.tpvServices.ticket_num_return
                    , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket
                    , this.globals.restaurant.printer_type
                    , false
                    , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.notes || '');
                //Acaba loader general
                loadingPopup.dismiss();
                clearInterval(interval_services);
            }, 3000);
        }


    }


    cancelTicket() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('instant-eliminar-ticket'),
            message: this.translate.instant('instant-seguro-quieres-cancelar-ticket'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.globals.GAtrackView('TPV', 'TPV - Ticket - Delete', this.globals.restaurant.email, 'Delete', 'Cancel TPV ticket ', 'TPV', '');
                        //data set waiter activity
                        var extra_activity: any =
                        {
                            'type': 'cancel',
                            'value': 1,
                            'source': 'tpv',

                        };
                        this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
                        this.tpvServices.cancelTicket('cancel');
                        this.tpvServices.deleteKeyboard();
                    }
                }
            ]
        });
        alert.present();
    }

    goToTables() {
        this.tpvServices.deleteKeyboard();
        this.tpvServices.menu_select_room = 'room';
        this.navCtrl.pop();
    }

    goToTakeAway() {
        if (this.globals.checkLimitsByLicense("tpv", "takeaway")) {
            if (this.globals.connection) {
                this.tpvServices.deleteKeyboard();
                //this.ordersCoServices.menu_select_room = 'take_away';
                this.tpvServices.menu_select_room = 'take_away';
                this.globals.side_menu_active = 'tk';
                this.navCtrl.setRoot(TpvLoaderPage);
            } else {
                this.globals.launchToastNoConnection();
            }
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }

    }

    openTickets() {
        if (this.globals.connection) {
            this.tpvServices.deleteKeyboard();
            this.navCtrl.push(ConfigurationTicketsPage, {
                headfooter: this.configurationServices.ticket_hedfoot,
            });
        } else {
            this.globals.launchToastNoConnection();
        }
    }

    openCalendar() {
        if (this.globals.connection) {
            this.tpvServices.deleteKeyboard();
            this.globals.side_menu_active = 'reservation';
            this.navCtrl.push(ReservationLoaderPage, {
                table_uid: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].UID
            });
        } else {
            this.globals.launchToastNoConnection();
        }
    }

    openMove2OtherTable() {
        if (this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].state != 'ticket') {
            if (this.globals.objectToArray(this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.list).length > 0) {
                this.navCtrl.push(TpvTicketChangeTablePage, {
                    table_uid: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].UID
                });
            } else {
                let toast = this.toastCtrl.create({
                    message: this.translate.instant('instant-mesa-contenido-transferir-otra-mesa'),
                    duration: 3000,
                    position: 'bottom'
                });
                toast.present();
            }
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('config-tickets-tickets-pendientes'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();

        }


    }


    changeCash() {
        this.navCtrl.push(TpvTicketSelectedCashPage);
    }

    pay() {
        //limpiar calculadora
        this.globals.tourLaunchStep(8);
        this.tpvServices.deleteKeyboard();
        //this.navCtrl.push(TpvTicketSelectedPayPage);
        //abre modal donde enseñaremos las categorias y que seleccione lo que quiere que se muestre(los seleccionades estaran en array)
        let profileModal = this.modalCtrl.create(PopupSelectPayment,
            {
                table: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index],
                origin: 'tpv'

            });
        profileModal.onDidDismiss(data => {
            if (data) {
                this.navCtrl.pop();
            }
        });
        profileModal.present();
    }

    async cashFastPay() {

        this.tpvServices.deleteKeyboard();
        //Caja rapida, buscamos el numero de ticket i lo cobaramos
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('instant-cobrando')
        });
        loadingPopup.present();

        await this.tpvServices.cashTicketPay('not specified', this.tpvServices.selected_type);
        loadingPopup.dismiss();
        this.globals.print_content = document.getElementById('print_list_ticket_normal');
        this.tpvServices.ticket_print = 'normal';

        let alert = this.alertCtrl.create({
            title: this.translate.instant('general-imprimir-ticket'),
            message: this.translate.instant('instant-seguro-quieres-imprimir-ticket'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                        this.tpvServices.cancelTicket('clean');
                        this.navCtrl.pop();
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        if (this.globals.restaurant.printer_type == 'native') {
                            this.printServices.printNow('print_list_ticket_normal');
                        } else {
                            this.printServices.prepareTicket(this.tpvServices.listSelectedTicket('name', this.globals.objectToArray(this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.list))[0]
                                , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.date.toDate()
                                , this.tpvServices.totalTicketSelectedNoTax(this.tpvServices.selected_table_tpv_index, this.globals.RESTAURANT_TAX)
                                , this.tpvServices.totalTicketSelected(this.tpvServices.selected_table_tpv_index)
                                , this.tpvServices.calculateIva(this.tpvServices.totalTicketSelected(this.tpvServices.selected_table_tpv_index), this.tpvServices.totalTicketSelectedNoTax(this.tpvServices.selected_table_tpv_index, this.globals.RESTAURANT_TAX), this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket)
                                , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.waiter
                                , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].room
                                , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].name
                                , this.globals.restaurant.tickets.footer
                                , 'tpv'
                                , this.tpvServices.ticket_num_return
                                , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket
                                , this.globals.restaurant.printer_type
                                , false
                                , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.notes || '');
                        }
                        this.tpvServices.cancelTicket('clean');
                        this.navCtrl.pop();
                    }
                }
            ]
        });
        alert.present();


    }

    openBarTicket() {
        this.tpvServices.deleteKeyboard();
        this.tpvServices.selected_table_tpv_index = this.tpvServices.table_bar_index;
        this.tpvServices.selected_type = 'bar';
        this.navCtrl.pop();
        this.navCtrl.push(TpvTicketPage);
    }

    openCreateInvoice() {
        if (this.globals.connection) {
            this.tpvServices.deleteKeyboard();
            this.navCtrl.push(InvoicesCreateSelectClientPage, {
                origin: 'tpv'
            });
        } else {
            this.globals.launchToastNoConnection();
        }

    }


    cashOutIn() {
        this.tpvServices.deleteKeyboard();
        this.navCtrl.push(TpvCashInoutCreatePage, {
            'cash_uid': this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].cash_uid
        });
    }

    blockScreen() {
        if (this.globals.connection) {
            this.tpvServices.deleteKeyboard();
            this.navCtrl.push(BlockScreenPage, {
                type: 'tpv',
            });
        } else {
            this.globals.launchToastNoConnection();
        }
    }

    openAddUnits() {
        var _tags;
        this.tpvServices.table_tmp = this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index];
        if (this.tpvServices.table_tmp.ticket != undefined && this.tpvServices.change_units == true && this.tpvServices.number_units != null) {
            //eliminar elementos que existen
            for (let key in this.tpvServices.table_tmp.ticket.list) {
                if (this.tpvServices._uid == this.tpvServices.table_tmp.ticket.list[key].uid_element) {
                    _tags = this.tpvServices.table_tmp.ticket.list[key].tags; //Guardamos los tags del elemento
                    delete this.tpvServices.table_tmp.ticket.list[key];
                }
            }
            //
            this.tpvServices.afs.collection('tables').doc(this.tpvServices.table_tmp.UID).update({
                ticket: this.tpvServices.table_tmp.ticket,
            }).then(doc => {
                //introducir de nuevo la cantidad que se quiere
                var units = this.tpvServices.number_units;

                if (this.tpvServices.k_screen != '') {
                    if (units < 0 || units == null) { //Si no hay numero lo ponemos a 1
                        for (var i = 0; i < 1; i++) {
                            this.tpvServices.insertTable(this.tpvServices._name, this.tpvServices._price, this.tpvServices._delete, this.tpvServices._count, this.tpvServices._type, this.tpvServices._uid, { tags: _tags });
                        }
                    } else {
                        for (var j = 0; j < units; j++) {
                            this.tpvServices.insertTable(this.tpvServices._name, this.tpvServices._price, this.tpvServices._delete, this.tpvServices._count, this.tpvServices._type, this.tpvServices._uid, { tags: _tags });
                        }
                    }
                }
                this.tpvServices.deleteKeyboard();
                this.tpvServices.change_units = false;
            });
            //en caso de no connexion hacemos lo que hay dentro del then pero fuera
            if (!this.globals.connection) {
                //introducir de nuevo la cantidad que se quiere
                var units = this.tpvServices.number_units;

                if (this.tpvServices.k_screen != '') {
                    if (units < 0 || units == null) { //Si no hay numero lo ponemos a 1
                        for (var i = 0; i < 1; i++) {
                            this.tpvServices.insertTable(this.tpvServices._name, this.tpvServices._price, this.tpvServices._delete, this.tpvServices._count, this.tpvServices._type, this.tpvServices._uid, { tags: _tags });
                        }
                    } else {
                        for (var j = 0; j < units; j++) {
                            this.tpvServices.insertTable(this.tpvServices._name, this.tpvServices._price, this.tpvServices._delete, this.tpvServices._count, this.tpvServices._type, this.tpvServices._uid, { tags: _tags });
                        }
                    }
                }
                this.tpvServices.deleteKeyboard();
                this.tpvServices.change_units = false;
            }
        }
        this.tpvServices.autoScrollEnterElements();
    }

    addElement() {
        this.navCtrl.push(TpvTicketSelectElementPage);
    }

    showInfoCustomer() {
        if (this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer.UID) {
            this.navCtrl.push(CustomersCreateDataPage, {
                update_state: true,
                customer_uid: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer.UID,
                name: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer.name,
                business_name: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer.business_name,
                business_number: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer.business_number,
                email: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer.email,
                phone: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer.phone,
                address: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer.address,
                note: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer.note,
                alegra_contact_id: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer.alegra_contact_id,
            })
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-no-hay-cliente'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-selected.ts